"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Validator that checks string against regular expression.
 *
 * @author Stepan Mik
 */

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");

var StringRegexValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(StringRegexValidator, _Validator_1$Validato);

  function StringRegexValidator(pattern, patternName) {
    var _this;

    _classCallCheck(this, StringRegexValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StringRegexValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.pattern = pattern;
    _this.patternName = patternName ? patternName : pattern.toString();
    return _this;
  }

  _createClass(StringRegexValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (this.pattern.exec(value)) {
        return new ValidationResult_1.ValidationSuccess(value);
      }

      return new ValidationResult_1.ValidationError(StringRegexValidator.DOES_NOT_MATCH_REGEX_ERROR, this.patternName);
    }
  }]);

  return StringRegexValidator;
}(Validator_1.Validator);

exports.StringRegexValidator = StringRegexValidator;
StringRegexValidator.DOES_NOT_MATCH_REGEX_ERROR = 'DOES_NOT_MATCH_REGEX';